import React, { ComponentType } from 'react'
import { createRoot } from 'react-dom/client'
import { RetorikAgent } from './components'

export default function renderAgent(RetorikAgent: ComponentType<any>, props: any, element: HTMLElement): void {
  const root = createRoot(element)
  root.render(<RetorikAgent {...props} />)
}

// WebComponent creation
class RetorikAgentWebComponent extends HTMLElement {
  constructor() {
    super()
  }

  // Mehod called when the element is connected to the DOM
  connectedCallback() {
    const tenant = this.getAttribute('tenant')
    const prefix = this.getAttribute('prefix')
    const props = JSON.parse(this.getAttribute('props') || '{}')

    if (tenant) {
      const addressData = {
        tenant: tenant,
        prefix: prefix
      }

      this._renderAgent({ ...props, addressData: addressData })
    }
  }

  // React component rendering
  private _renderAgent(props: any) {
    const root = createRoot(this)
    root.render(<RetorikAgent {...props} />)
  }
}

// WebComponent registering in window
window.customElements.define('retorik-agent', RetorikAgentWebComponent)
